import WebDevicesList from './WebDevicesList';

export default WebDevicesList;
